import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import searchRequestAtom from '../../recoils/useSearchRequest/searchRequestAtom';
import { UtagContext } from '../../context/UtagContext';
import './part-display-option.scss';
import { ISearchQueryRequest } from '../../models/ISearchQueryRequest';

interface IProps {
  onApplyActive: (isActivePartInclude: boolean) => void;
  onApplyMarketplace: (isMarketplaceInclude: boolean) => void;
  onApplyExcludeTariff: (isExcludeTariff: boolean) => void;
  onApplyStocking: (isStockingInclude: boolean) => void;

  isActiveChecked: boolean;
  isMarketplaceChecked: boolean;
  isStockingChecked: boolean;
  isExcludeTariffChecked: boolean;
  isTariffActive: boolean;
  isTabCompareAtt: boolean;
}

const PartDisplayOption: React.FC<IProps> = (props) => {
  const utagContext = useContext(UtagContext);
  const [searchQuery, setSearchQuery] = useRecoilState(searchRequestAtom);
  const {
    onApplyActive,
    onApplyMarketplace,
    onApplyExcludeTariff,
    onApplyStocking,
    isActiveChecked,
    isMarketplaceChecked,
    isExcludeTariffChecked,
    isStockingChecked,
    isTariffActive,
    isTabCompareAtt
  } = props;

  const { t } = useTranslation();

  const [isActivePartCheck, setIsActivePartCheck] = useState(false);
  const [isStockingCheck, setIsStockingCheck] = useState(false);
  const [isMarketPlaceCheck, setIsMarketPlaceCheck] = useState(false);
  // state to save checkbox exclude tariff checked or not
  const [isExcludeTariffCheck, setIsExcludeTariffCheck] = useState(false);

  const includeActivePartHandler = (event: any) => {
    let updateRequest = { ...searchQuery };
    if (event.target.checked === false) {
      setIsActivePartCheck(false);
      delete updateRequest.productStatusFilter;
    } else {
      updateRequest = {
        ...updateRequest,
        productStatusFilter: [{id: "0"}] //productStatus for Active is 0
      };
      setIsActivePartCheck(true);
    }
    setSearchQuery(updateRequest);
    utagContext.setRef('Result Options');
    onApplyActive(event.target.checked);
  };

  const marketPlacePartHandler = async (event: any) => {
    let updateRequest = { ...searchQuery };
    if (event.target.checked === false) {
      setIsMarketPlaceCheck(false);
      updateRequest = { ...updateRequest, marketPlaceFilter: undefined };
      delete updateRequest.marketPlaceFilter;
    } else {
      updateRequest = {
        ...updateRequest,
        marketPlaceFilter: 'ExcludeMarketPlace'
      };
      setIsMarketPlaceCheck(true);
    }
    setSearchQuery(updateRequest);
    utagContext.setRef('Result Options');
    onApplyMarketplace(event.target.checked);
  };

  // function exclude tariff filter
  const ExcludeTariffHandler = async (event: any) => {
    let updateRequest = { ...searchQuery };
    if (event.target.checked === false) {
      setIsExcludeTariffCheck(event.target.checked);
      updateRequest = { ...updateRequest, excludeFilter: undefined };
      delete updateRequest.excludeFilter;
    } 
    else {
      updateRequest = {
        ...updateRequest,
        excludeFilter: ["ExcludeTariff"]
      };
      setIsExcludeTariffCheck(true);
    }
    setSearchQuery(updateRequest);
    utagContext.setRef('Result Options');
    onApplyExcludeTariff(event.target.checked);
  };

  const stockingHandler = async (event: any) => {
    let updateRequest: ISearchQueryRequest = { ...searchQuery };
    // need to updated if use searchOptions
    if (event.target.checked === false) {
      updateRequest = { ...updateRequest, searchOptions: undefined };
      delete updateRequest.searchOptions;
      setIsStockingCheck(false);
    } else {
      let searchOptions: string[] = updateRequest.searchOptions
        ? [...updateRequest.searchOptions, 'InStock']
        : ['InStock'];
      updateRequest = { ...updateRequest, searchOptions: [...searchOptions] };
      setIsStockingCheck(true);
    }
    setSearchQuery(updateRequest);
    utagContext.setRef('Result Options');
    onApplyStocking(event.target.checked);
  };

  useEffect(() => {
    setIsActivePartCheck(isActiveChecked);
    setIsMarketPlaceCheck(isMarketplaceChecked);
    setIsStockingCheck(isStockingChecked);
    setIsExcludeTariffCheck(isExcludeTariffChecked);
  }, [isActiveChecked, isMarketplaceChecked, isStockingChecked, isExcludeTariffChecked]);

  return (
    <div className="part-display-box">
      <div className="dk-checkbox-group" id="include-active-cb-gr">
        <input
          type="checkbox"
          className="dk-checkbox"
          id="include-active-cb"
          data-testid="include-active-cb"
          onChange={includeActivePartHandler}
          checked={isActivePartCheck ? true : false}
          {...{ ref_page_event: 'Result Options' }}
        />
        <label
          className="dk-checkbox-label "
          id="include-active-lb"
          htmlFor="include-active-cb"
        >
          {t('xref-search-ctr-active-parts')}
        </label>
      </div>
      <div className="dk-checkbox-group" id="include-active-cb-gr">
        <input
          type="checkbox"
          className="dk-checkbox"
          data-testid="stocking-cb"
          id="stocking-cb"
          onChange={stockingHandler}
          checked={isStockingCheck ? true : false}
          {...{ ref_page_event: 'Result Options' }}
        />
        <label
          className="dk-checkbox-label "
          id="include-active-lb"
          htmlFor="stocking-cb"
        >
          {t('xref-search-ctr-in-stock')}
        </label>
      </div>
      <div className="dk-checkbox-group" id="include-active-cb-gr">
        <input
          type="checkbox"
          className="dk-checkbox"
          data-testid="marketplace-cb"
          id="marketplace-cb"
          onChange={marketPlacePartHandler}
          checked={isMarketPlaceCheck ? true : false}
          {...{ ref_page_event: 'Result Options' }}
        />
        <label
          className="dk-checkbox-label "
          id="include-active-lb"
          htmlFor="marketplace-cb"
        >
          {t('xref-search-ctr-exclude-marketplace')}
        </label>
      </div>
      {/* check box exclude tariff */}
      {isTariffActive && (
        <div className="dk-checkbox-group" id="exclude-tariff-cb-gr">
          <input
              type="checkbox"
              className="dk-checkbox"
              data-testid="exclude-tariff-cb"
              id="exclude-tariff-cb"
              onChange={ExcludeTariffHandler}
              checked={(isTabCompareAtt && isExcludeTariffCheck) ? true : false}
              {...{ ref_page_event: 'Result Options' }}
              disabled={!isTabCompareAtt}
          />
          <label
            className={!isTabCompareAtt ? "dk-checkbox-label checkbox-disabled" : "dk-checkbox-label"}
            id="include-active-lb"
            htmlFor="exclude-tariff-cb"
          >
            {t('xref-search-ctr-exclude-tariff')}
          </label>
        </div>
      )}
    </div>
  );
};

export default PartDisplayOption;
